<script>
  import { Size } from "./enums";
  import Label from "./Label.svelte";

  export let label;
  export let value;
  export let options = [];
  export let labelClasses = "";
  export let size = Size.Medium;
  export let border = true;

  const selectId = `select-${label.trim()}`;

  let focused = false;

  function handleFocusIn() { focused = true; }
  function handleFocusOut() { focused = false; }

  $: sizeClasses = {
    [Size.Small]: "h-5 pl-1.5",
    [Size.Medium]: "h-10 pl-3.5"
  }[size];

  $: fontClasses = {
    [Size.Small]: "text-xs font-normal",
    [Size.Medium]: "text-base font-medium"
  }[size];

  $: borderClasses = border ? "border rounded" : "";

  $: wrapperFocusedClasses = focused ? "border-primary-400 ring-2 ring-primary-300 border-opacity-50" : "border-gray-500 hover:border-gray-600 border-opacity-75";
  $: wrapperClasses = `flex items-center ${borderClasses} ${sizeClasses} ${wrapperFocusedClasses}`;

</script>

<Label text={label} forId={selectId} classes={labelClasses} />

<div class={wrapperClasses}>
  <select
    id={selectId}
    class="appearance-none border-0 ring-0 px-0 bg-transparent w-full cursor-inherit placeholder-gray-600 focus:outline-none focus:ring-0 border-primary-400 {fontClasses} text-gray-950"
    on:focusin={handleFocusIn}
    on:focusout={handleFocusOut}
    bind:value={value}
  >
    {#each options as option}
      <option class="{fontClasses}" value={option.value} selected={value == option.value}>
        {@html option.name}
      </option>
    {/each}
  </select>
  <svg
      class="inline-block fill-current w-4 h-4 text-gray-800 mr-2"
      focusable="false"
      viewBox="0 0 24 24"
    >
      <path d="M5.29289 8.29289C4.90237 8.68342 4.90237 9.31658 5.29289 9.70711L11.2929 15.7071C11.6834 16.0976 12.3166 16.0976 12.7071 15.7071L18.7071 9.70711C19.0976 9.31658 19.0976 8.68342 18.7071 8.29289C18.3166 7.90237 17.6834 7.90237 17.2929 8.29289L12 13.5858L6.70711 8.29289C6.31658 7.90237 5.68342 7.90237 5.29289 8.29289Z" />
    </svg>
</div>
